import type { PuzzleData } from '@/types/puzzle';

import { puzzle1 } from './puzzle1';
import { emberdeepFinale, arcanaPack } from './arcana';

// Single source of truth for all playable levels.
// Keep earlier indices stable by only appending new packs.
export const puzzles: PuzzleData[] = [...puzzle1, ...emberdeepFinale, ...arcanaPack];
